import { v4 as uuidv4 } from 'uuid';

const alignement = [
    {
        idSoft: uuidv4(),
        name: 'Center',
        value: 'center',
        alignement: 'center',
    },
    {
        idSoft: uuidv4(),
        name: 'Left',
        value: 'left',
        alignement: 'flex-start',
    },
    {
        idSoft: uuidv4(),
        name: 'Right',
        value: 'right',
        alignement: 'flex-end',
    }
];

export default alignement;
